import Layouts from "../layout/Layouts";
import LazyComponent from "./LazyComponent";
import PrivateRoute from "./protected/PrivateRoute";
import PublicRoute from "./public/PublicRoute";
export const SiteMap = {
  home: {
    title: "home",
    path: "/",
    element: <LazyComponent path="home/home" />,
    description: "home-Page",
  },
  businessProfile: {
    title: "businessProfileome",
    path: "/businessProfile",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="businessProfile/BusinessProfile" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "businessProfile-Page",
  },

  BusinessWall: {
    title: "BusinessWall",
    path: "/businessWall",

    element: (
      // <PublicRoute>
      <Layouts>
        <LazyComponent path="businessWall/BusinessWall" />
      </Layouts>
      // </PublicRoute>
    ),
    description: "BusinessWall-Page",
  },

  BusinessWallpost: {
    title: "BusinessWall",
    path: "/businessWall/:postId",
    element: (
      // <PublicRoute>
      <Layouts>
        <LazyComponent path="businessWall/BusinessWall" />
      </Layouts>
      // </PublicRoute>
    ),
    description: "BusinessWall-Page",
  },
  eventsBusiness: {
    title: "eventsBusiness",
    path: "/eventsBusiness",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="eventsBusiness/EventsBusiness" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "eventsBusiness-Page",
  },
  FoodDrictory: {
    title: "FoodDrictory",
    path: "/foodDrictory",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="FoodDrictory/FoodDrictory" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "eventsBusiness-Page",
  },
  Categories: {
    title: "Categories",
    path: "/categories",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="categories/Categories" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "Categories-Page",
  },
  Chat: {
    title: "Chat Screen",
    path: "/chat/:freelancerId",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="Chat/Chat" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "Chat with Freelancer",
  },
  inbox: {
    title: "Chat Screen",
    path: "/chat",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="Chat/Chat" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "Chat with Freelancer",
  },

  EdgeBusinessesPage: {
    title: "EdgeBusinessesPage",
    path: "/edgeBusinessesPage",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="EdgeBusinessesPage/EdgeBusinessesPage" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "EdgeBusinessesPage-Page",
  },
  Profile: {
    title: "Profile",
    path: "/profile",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="profile/Profile" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "Profile-Page",
  },
  paymentSuccess: {
    title: "Payment successfull",
    path: "/payment-success",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="payment/success" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "Payment successfull",
  },
  paymentFail: {
    title: "Payment Failed",
    path: "/payment-failed",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="payment/failed" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "Payment Failed",
  },
  RestaurantProfile: {
    title: "Restaurant Profile",
    path: "/restaurant-profile",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="restaurantProfile/Profile" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "Restaurant Profile",
  },
  ProfessionalProfile: {
    title: "ProfessionalProfile",
    path: "/professionalProfile",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="ProfessionalProfile/ProfessionalProfile" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "ProfessionalProfile",
  },
  PricingTable: {
    title: "PricingTable",
    path: "/pricingTable",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="PricingTable/PricingTable" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "PricingTable",
  },
  AboutUs: {
    title: "AboutUs",
    path: "/aboutUs",
    element: (
      // <PublicRoute>

      <Layouts>
        <LazyComponent path="AboutUs/AboutUs" />
      </Layouts>
      // </PublicRoute>

    ),
    description: "PrivacyPolicy",
  },
  DeleteAccount: {
    title: "DeleteAccount",
    path: "/deleteAccount",
    element: (
      <Layouts>
        <LazyComponent path="DeleteAccount/DeleteAccount" />
      </Layouts>
    ),
    description: "DeleteAccount",
  },
  PrivacyPolicy: {
    title: "PrivacyPolicy",
    path: "/privacyPolicy",
    element: (
      // <PublicRoute>

      <Layouts>
        <LazyComponent path="PrivacyPolicy/PrivacyPolicy" />
      </Layouts>
      // </PublicRoute>

    ),
    description: "PrivacyPolicy",
  },
  ContactUs: {
    title: "ContactUs",
    path: "/contactUs",
    element: (
      // <PublicRoute>

      <Layouts>
        <LazyComponent path="ContactUs/ContactUs" />
      </Layouts>
      // </PublicRoute>

    ),
    description: "ContactUs",
  },
  ManageProfessional: {
    title: "ManageProfessional",
    path: "/manageProfessional",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="ManageProfessional/ManageProfessional" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "ManageProfessional",
  },
  signup: {
    title: "signup",
    path: "/signup",
    // element: <LazyComponent path="auth/signup" />,
    element: (
      <PublicRoute>
        <LazyComponent path="auth/signup" />
      </PublicRoute>
    ),
    description: "signup",
  },
  Register: {
    title: "Register",
    path: "/Register",
    // element: <LazyComponent path="auth/Register" />,
    element: (
      <PublicRoute>
        <LazyComponent path="auth/Register" />
      </PublicRoute>
    ),
    description: "Register",
  },
  login: {
    title: "login",
    path: "/login",
    // element: <LazyComponent path="auth/login" />,
    element: (
      <PublicRoute>
        <LazyComponent path="auth/login" />
      </PublicRoute>
    ),
    description: "login",
  },
  Forget: {
    title: "forget",
    path: "/forget-password",
    // element: <LazyComponent path="auth/forget" />,
    element: (
      <PublicRoute>
        <LazyComponent path="auth/forget" />
      </PublicRoute>
    ),
    description: "forget",
  },
  reset: {
    title: "Reset Password",
    path: "/reset-password",
    // element: <LazyComponent path="auth/resetPassword" />,
    element: (
      <PublicRoute>
        <LazyComponent path="auth/resetPassword" />
      </PublicRoute>
    ),
    description: "Reset Password",
  },
  upUpcomingEvents: {
    title: "upUpcomingEvents",
    path: "/UpcomingEvents",
    element: <LazyComponent path="UpComingEvents/UpComingEvents" />,
    description: "EventsUpComing",
  },
  createHighlight: {
    title: "createHighlight",
    path: "/createHighlight",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="FoodDrictory/InspirationOrder/highlightForm" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "businessProfile-Page",
  },

  createSlide: {
    title: "createSlide",
    path: "/createSlide",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="FoodDrictory/OurSpecials/createSlide" />
        </Layouts>
      </PrivateRoute>
    ),
    description: "businessProfile-Page",
  },
  createEvent: {
    title: "createEvent",
    path: "/createEvent",
    element: (
      <PrivateRoute>
        <Layouts>
          <LazyComponent path="home/createEvent" />,
        </Layouts>
      </PrivateRoute>
    ),
    description: "businessProfile-Page",
  },
  // restaurants: {
  //   title: "Restaurants",
  //   path: "/restaurants",
  //   element: <LazyComponent path="restaurantProfile/Restaurants" />,
  //   description: "restaurants-Page",
  // },
  restaurants: {
    title: "Restaurants",
    path: "/restaurants",
    element: (
      // <PrivateRoute>
      <LazyComponent path="restaurantProfile/Restaurants" />
      // </PrivateRoute>
    ),
    description: "restaurants-Page",
  },
  // employees: {
  //   title: "Employee",
  //   path: "/employees",
  //   element: <LazyComponent path="employee/Employee" />,
  //   description: "employees-Page",
  // },

  employees: {
    title: "Employee",
    path: "/employees",
    element: (
      // <PrivateRoute>
      <LazyComponent path="employee/Employee" />
      // </PrivateRoute>
    ),
    description: "employees-Page",
  },
  employeeProfile: {
    title: "employeeProfile",
    path: "/employeeProfile",
    element: (
      // <PublicRoute>
      <Layouts>
        <LazyComponent path="employeeProfile/EmployeProfile" />
      </Layouts>
      // </PublicRoute>
    ),
    description: "employeeProfile-Page",
  },
  Calendar: {
    title: "calendar",
    path: "/calendar",
    element: (
      // <PublicRoute>
      <Layouts>
        <LazyComponent path="calendar/calendar" />
      </Layouts>
      // </PublicRoute>
    ),
    description: "calendar-Page",
  },

  CategoryCards: {
    title: "CategoryDetail",
    path: "/categories/:categoryName",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="home/Categories/CategoryCards" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "CategoryCards-Page",
  },
  AllUserProfilesPage: {
    title: "AllUserProfilesPage",
    path: "/user-profiles/all",
    element: (
      // <PrivateRoute>
      <Layouts>
        <LazyComponent path="allUserProfilesPage/AllUserProfilesPage" />
      </Layouts>
      // </PrivateRoute>
    ),
    description: "AllUserProfilesPage-Page",
  },
};
